import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthProvider } from './contexts/AuthContext'
import { RoleProvider } from './contexts/RoleContext'
import { ClientProvider } from './contexts/ClientContext'
import { Layout } from './components/Layout'
import { RoleBasedDashboard } from './pages/RoleBasedDashboard'
import { PartnerDashboard } from './pages/partner/PartnerDashboard'
import { ClientDetail } from './pages/ClientDetail'
import { Billing } from './pages/Billing'
import { ClientDashboard } from './pages/client/ClientDashboard'
import { InstanceWizard } from './pages/client/InstanceWizard'
import { InstanceDetail } from './pages/client/InstanceDetail'
import { Subscription } from './pages/client/Subscription'
import { Users } from './pages/client/Users'
import { Login } from './pages/Login'
import { AuthCallback } from './pages/AuthCallback'
import { ProtectedRoute } from './components/ProtectedRoute'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        {/* Root redirects to role-based dashboard */}
        <Route index element={<RoleBasedDashboard />} />

        {/* Partner Routes */}
        <Route path="partner">
          <Route path="dashboard" element={<PartnerDashboard />} />
          <Route path="clients/:clientId" element={<ClientDetail />} />
          <Route path="billing" element={<Billing />} />
        </Route>

        {/* Client Routes */}
        <Route path="client">
          <Route path="dashboard" element={<ClientDashboard />} />
          <Route path="instances/create" element={<InstanceWizard />} />
          <Route path="instances/:instanceId" element={<InstanceDetail />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="users" element={<Users />} />
        </Route>
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <RoleProvider>
            <ClientProvider>
              <AppRoutes />
            </ClientProvider>
          </RoleProvider>
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
